import React from "react";

export default function PopupBody(props) {

  return(
    <div className="popup-fixed-body">
      {props.children}
    </div>
  );
}